import { generateDynamicRoutesTranslations, LANGUAGES } from './common';
import en from '../translations/en.json';

import extraEN from '../translations/en_ks.json';

export const SUPPORTED_LANGUAGES = [LANGUAGES.en];
export const DEFAULT_LANGUAGE = LANGUAGES.en;

export const initResources = {
  [LANGUAGES.en]: {
    translation: { ...en, ...extraEN, dynamicRoutes: { ...generateDynamicRoutesTranslations(LANGUAGES.en) } }
  }
};
